import { notification } from "antd";
import "antd/dist/antd.less";
import React, { FunctionComponent, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { getSharedReportByGuid } from "../../../Actions/ShareActions";
import GPSInsightsReportContainer from "../../../Components/Apps/GPSInsights/GPSInsightsReportContainer";
import RetailMatchReportContainer from "../../../Components/Apps/RetailMatch/Components/RetailMatchReportContainer";
import { ComponentLoading } from "../../../Components/Common/";
import { ReportTypeEnum } from "../../../Enums/ReportTypeEnum";
import { IRootReducer } from "../../../Models/Models";

// interface ISharedContentProps extends RouteComponentProps { }
interface ISharedContentStateProps { }
interface ISharedContentDispatchProps { }

type ISharedContentProps = ISharedContentStateProps &
    ISharedContentDispatchProps &
    RouteComponentProps;

export const mapStateToProps = (
    state: IRootReducer
): ISharedContentStateProps => ({});
export const mapDispatchToProps = (
    state: IRootReducer
): ISharedContentDispatchProps => ({});

const _SharedContent: FunctionComponent<ISharedContentProps> = (
    props: ISharedContentProps
) => {
    const dispatch = useDispatch();
    const [reportType, setReportType] = useState<string>();

    const url: URL = new URL(window.location.href);
    const pathnameArray: Array<string> = url.pathname.split("/");
    const guid = pathnameArray[pathnameArray.length - 1].replace("=", "");

    useEffect(() => {
        setReportType(guid.substr(0, guid.indexOf("_")));

        if (guid) {
            dispatch(getSharedReportByGuid(guid));
        } else {
            notification.error({
                message: "Error retrieving Shared Content",
                description: `There was a problem while retrieving the requested shared content due to invalid report identifier.`,
                duration: null,
            });
        }
    }, []);

    switch (reportType) {
        case ReportTypeEnum.Mobilytics:
            return (
                <GPSInsightsReportContainer
                    isSharing={true}
                    pathname={url.pathname}
                    jobId={null}
                    user={null}
                    isScout={true}
                />
            );

        case ReportTypeEnum.RetailMatch:
            return <RetailMatchReportContainer
                isSharing={true}
                jobId={null}
                brandId={null}
                isScout={true}
            />;

        default:
            return <ComponentLoading title="Loading Content" />;
    }
};

export const SharedContent = withRouter(
    connect<ISharedContentStateProps, ISharedContentDispatchProps, any>(
        mapStateToProps,
        mapDispatchToProps
    )(_SharedContent)
);
